import CardDsl from './CardDsl'
import CardPrice from './CardPrice'
import { CourseInfo } from './CourseCard/CourseInfo'

import PropTypes from 'prop-types'

const ActivityCardDsl = ({ trip, isWidget }) => {
  if(!trip.activityType) {
    return
  }

  return (
    <CardDsl adventure={trip} activityPage={trip.activityPage}>
      <CourseInfo adventure={trip} infoType='adventure' isOtherActivity />
      <CardPrice
        adventure={trip}
        type='adventure'
        isWidget={isWidget}
        isOtherActivity
        activityPage={trip.activityPage}
        externalPage={trip?.externalUrl}
      />
    </CardDsl>
  )
}

export default ActivityCardDsl

ActivityCardDsl.propTypes = {
  trip: PropTypes.object.isRequired,
  isWidget: PropTypes.bool,
}
